import dynamic from 'next/dynamic';
import React from 'react';
import type { AuthFlow } from '../../../types/enums';
import type { BannerAlertProps } from '../../common/BannerAlert/BannerAlert';
import type { RegistrationFormData } from '../RegistrationForm/RegistrationForm';

const AuthenticationModalMain = dynamic(() => import('./AuthenticationModalMain'), {
  ssr: false
});

export interface Props {
  /**
   * Whether the modal is currently being displayed
   */
  show: boolean;
  /**
   * Callback function when the modal is hidden
   *
   * @callback
   * @param boolean - The state of the modal.
   */
  onHide: () => void;
  /**
   * Callback function after login.
   *
   * @callback
   */
  onLogin: () => void;
  /**
   * Callback function after login.
   *
   * @callback
   */
  onRegistration: (formData: RegistrationFormData) => void;
  /**
   * Callback function after form is submitted successfully.
   *
   * @callback
   */
  onForgotPass: () => void;

  /**
   * Type of authentication flow to use.
   */
  type?: AuthFlow;

  /**
   * Props to render Banner form alerts in the form.
   */
  loginBannerAlertProps?: BannerAlertProps;
}

const AuthenticationModal: React.FC<Props> = ({
  show,
  onHide,
  onLogin,
  onForgotPass,
  onRegistration,
  loginBannerAlertProps,
  type
}) => {
  if (show) {
    return (
      <AuthenticationModalMain
        show={show}
        onHide={onHide}
        onLogin={onLogin}
        onForgotPass={onForgotPass}
        onRegistration={onRegistration}
        loginBannerAlertProps={loginBannerAlertProps}
        type={type}
      />
    );
  }
  return null;
};

export default AuthenticationModal;
